module.exports = __webpack_public_path__ + "static/media/virus-icon1.b2248e30.ico";